
/**
 * 페이지 번호 (0부터 시작)
 */
export type PageParameterParameter = number;
